import "./ApprovedTemplate.css";
import {baseURL} from '../Constant'
import CircularProgress from '@mui/material/CircularProgress';

const ApprovedTemplate = (props) => {    
    const microsoftDocViewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=`;            
    const fileName = props.outputFileName.split("===")[1];   
    const fileUrl = `${baseURL}/file/output/${fileName}`;
    console.log("props.certificateLoading--", props.certificateLoading);    

    return (
        <div className="data-display-new">
            {props.certificateLoading ? <CircularProgress style={{margin: '30px 50px 50px 50px'}} /> : 
            <div className="result-container">
                <div className="result-wrap">                    
                    <iframe
                        title="pptx-viewer"
                        src={microsoftDocViewerUrl + encodeURIComponent(fileUrl)}
                        width="100%"
                        height="600px"                                                        
                    />                    
                </div>
                <div className="file-footer">
                    <div className="return-wrap">
                        {props.backButton === 'enabled' && <p
                        onClick={() => {
                            props.setActiveScreen("default");
                            props.setL2("");
                        }}
                        >
                        {"<"} Back
                        </p>}                        
                    </div>
                    <div className="return-wrap">
                        <a href={`${baseURL}//file/output/${fileName}`} download>
                            <button className="file-dwnl-btn">Download</button>
                        </a>
                    </div>                                            
                </div>                
            </div>}
        </div>
    )
}

export default ApprovedTemplate;
